(function($, Proud) {
  Proud.behaviors.proudChild = {
    attach: function(context, settings) {
      // Run height equalizer
      $('.equalize-columns').once('equalize-default', function() {
        $(this).equalizeHeight(false, '.panel-grid-cell > *');
      });
      // Run height equalizer on images
      $('.equalize-column-images').once('equalize-default', function() {
        $(this).equalizeHeight(false, '.panel-grid-cell img');
      });
      // Make title in image widget clickable
      $('.so-widget-sow-image').each(function() {
        var href = $(this).find('a').attr('href');
        if (href) {
          $(this).bind('click', function() {
            window.location.href = href;
          }).addClass('fake-link');
        }
      });

      // Add agency menus to mobile menu
      var agencyMenu = $('.widget-agency-menu');
      if (agencyMenu.length) {
        var $container = $('#navbar-external .below ul');
        $container.append('<li role="separator" class="divider mobile-only"></li>');
        $('.list-group .level-1 a', agencyMenu).each(function() {
          $container.append('<li class="mobile-only"><a href="'+ $(this).attr('href') +'">'+ $(this).text() +'</a>')
        });
      }
    }
  };
})(jQuery, Proud);